module.exports = __webpack_public_path__ + "static/cercazone_hero1-0be3e41e33d043a69b3684a55f3196c8.jpg";